import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {RedirectRequest} from '../../interfaces/switchpay/RedirectRequest';
import {SwitchpayPaymentUpdateRequest} from '../../interfaces/switchpay/SwitchpayPaymentUpdateRequest';

@Injectable()
export class SwitchpayApi extends HttpClient {

  private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/switchpay' : environment.baseUrl + '/switchpay';
  private callBackBaseUrl = environment.baseUrlCallback + '/callback/switchpay';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initializeSwitchpay(sessionToken: string) {
    const url = `${this.baseUrl}/initialize/${sessionToken}`;
    return super.post(url, null);
  }

  public redirectSwitchpay(sessionToken: string, redirectRequest: RedirectRequest) {
    const url = `${this.callBackBaseUrl}/redirect/${sessionToken}`;
    return super.post(url, redirectRequest);
  }

  public validateSwitchpay(sessionToken: string, switchpayPaymentUpdateRequest: SwitchpayPaymentUpdateRequest): Observable<any> {
    const url = `${this.baseUrl}/validate?sessionToken=${sessionToken}`;
    return super.post(url, switchpayPaymentUpdateRequest);
  }

}
